// extracted by mini-css-extract-plugin
export default {"Icon":"AnimatedUpdateIcon_Icon__a2hDy"};